import React from 'react';
import { TasksAssignedDetailScreen } from './TasksAssignedDetailScreen';
import { TasksAssignedListScreen } from './TasksAssignedListScreen';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

const Stack =
  createNativeStackNavigator<NavigationStacks[Stacks.TasksAssigned]>();

export const TasksAssignedScreen: React.FC<{ pageKey: string }> = ({
  pageKey,
}) => {
  return (
    <Stack.Navigator
      initialRouteName={Screens.TasksAssignedList}
      screenOptions={{
        headerShown: false,
        animation: 'default',
      }}
    >
      <Stack.Screen
        name={Screens.TasksAssignedList}
        component={TasksAssignedListScreen}
        initialParams={{ pageKey: pageKey }}
      ></Stack.Screen>
      <Stack.Screen
        name={Screens.TasksAssignedDetail}
        component={TasksAssignedDetailScreen}
      ></Stack.Screen>
    </Stack.Navigator>
  );
};
